import * as React from "react";
import styled from "styled-components";

export const enum Direction {
  RIGHT = 0,
  BOTTOM = 90,
  LEFT = 180,
  TOP = 270
}

interface Props {
  direction?: Direction,
  color?: string
}

interface SvgProps {
  direction: Direction
}

const Svg = styled.svg`
  transform: rotate(${(props: SvgProps) => props.direction}deg);
`;

export const ArrowIcon: React.SFC<Props> = (props: Props) => {
  const { direction, color } = props;

  return (
    <Svg direction={direction} viewBox="0 0 21 20" width="20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 9.6L10.4 0 9 1.4 16.6 9H0v2h16.6L9 18.6l1.4 1.4 9.6-9.6.394-.4"
        fill={color}
        fillRule="evenodd"
      />
    </Svg>
  );
};

ArrowIcon.defaultProps = {
  direction: Direction.RIGHT,
  color: '#fff'
};

export default ArrowIcon;



// WEBPACK FOOTER //
// ./src/components/ArrowIcon.tsx